/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-04 11:52:25
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-04 17:44:01
 * @FilePath: /unifyxp-v2-store-portal/src/components/ErrorBoundary/index.tsx
 */
import React from 'react';
import * as Sentry from '@sentry/react';

const ErrorBoundaryHOC = (Component: any) => {
  const WrappedComponent = (props) => {
    return (
      <ErrorBoundary>
        <Component {...props} />
      </ErrorBoundary>
    );
  };
  return WrappedComponent;
};

// class ErrorBoundary extends React.Component<any, any> {
//   constructor(props) {
//     super(props);
//     this.state = { hasError: false };
//   }

//   static getDerivedStateFromError(error) {
//     // 更新 state 使下一次渲染能够显示降级后的 UI
//     return { hasError: true };
//   }

//   //   componentDidCatch(error, errorInfo) {
//   //     // 你同样可以将错误日志上报给服务器
//   //     //logErrorToMyService(error, errorInfo);
//   //   }

//   render() {
//     const { hasError } = this.state;
//     if (hasError) {
//       // 你可以自定义降级后的 UI 并渲染
//       return <h1>出现异常，请尝试刷新页面或者联系管理员</h1>;
//     }

//     return this.props.children;
//   }
// }
export default ErrorBoundaryHOC;

const ErrorBoundary = (props: any) => {
  return (
    <Sentry.ErrorBoundary
      fallback={props.fallback || <p>An error has occurred</p>}>
      {props.children}
    </Sentry.ErrorBoundary>
  );
};

// 出错后显示的元素类型
// type FallbackElement = React.ReactElement<
//   unknown,
//   string | React.FC | typeof React.Component
// > | null;

// // 出错显示组件的 props
// export interface FallbackProps {
//   error: Error;
// }

// // 本组件 ErrorBoundary 的 props
// interface ErrorBoundaryProps {
//   fallback?: FallbackElement;
//   onError?: (error: Error, info: string) => void;
// }

// // 本组件 ErrorBoundary 的 props
// interface ErrorBoundaryState {
//   error: Error | null; // 将 hasError 的 boolean 改为 Error 类型，提供更丰富的报错信息
// }

// // 初始状态
// const initialState: ErrorBoundaryState = {
//   error: null,
// };

// class ErrorBoundary extends React.Component<
//   React.PropsWithChildren<ErrorBoundaryProps>,
//   ErrorBoundaryState
// > {
//   state = initialState;

//   static getDerivedStateFromError(error: Error) {
//     return { error };
//   }

//   componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
//     if (this.props.onError) {
//       this.props.onError(error, errorInfo.componentStack);
//     }
//   }

//   render() {
//     const { fallback } = this.props;
//     const { error } = this.state;
//     const _fall = fallback || <div>Error</div>;
//     if (error !== null) {
//       if (React.isValidElement(_fall)) {
//         return _fall;
//       }

//       throw new Error('ErrorBoundary 组件需要传入 fallback');
//     }

//     return <React.Fragment>{this.props.children}</React.Fragment>;
//   }
// }
export { ErrorBoundary };
